"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var _default = exports.default = {
  PropTypes: {
    src: _propTypes.default.string,
    alt: _propTypes.default.string,
    height: _propTypes.default.string,
    width: _propTypes.default.string,
    theme: _propTypes.default.string,
    radius: _propTypes.default.string,
    type: _propTypes.default.string,
    borderColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    hoverAnimation: _propTypes.default.bool,
    centerFocus: _propTypes.default.bool,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    placeHolderBackground: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
    enableProgressiveImageLoading: _propTypes.default.bool,
    lowResolutionImageUrl: _propTypes.default.string,
    lazyLoadImage: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    height: 'initial',
    width: 'initial',
    accessible: true,
    placeHolderBackground: _constant2.DEFAULT_BACKGROUND,
    enableProgressiveImageLoading: false,
    lazyLoadImage: false,
    centerFocus: false
  }
};